import { ADD } from '../actionTypes'

export const addPhoto = (data: object) => ({
  type: ADD.name,
  api: {
    url: 'photos/add',
    data,
  },
})
